<template>
  <div>
    <button v-if="canAdd" class="cart-btn" @click="addToCart">Add to Cart</button>
    <span v-else>
      <button style="background:#e05024" class="cart-btn remove-btn" @click="removeFromCart(productItem)"><i class="fa fa-trash"></i> Remove from Cart</button>
      <button style="line-height:2em" class="cart-btn view-btn" @click="redir('cart')"><i class="fa fa-shopping-cart"></i> View Cart</button>
    </span>
  </div>
</template>
<style>
 .cart-btn{
   width: 100%;
    border: none;
    border-radius: 5px;
    box-shadow: none;
    white-space: nowrap;
    color: #fff;
    padding: 10px 30px;
    font-size: 16px;
    font-family: 'Montserrat', sans-serif;
    background: #ee992b;
    /* background: #ffc13b; */
    letter-spacing: 1px;
    position: relative;
    text-align: center;
    z-index: 1;
 }

 .remove-btn{
   background: #ee2b2b;
 }

  .view-btn{
    background: #dde3e9;
    color:#000000;
  }

 @media only screen 
  and (min-device-width: 320px) 
  and (max-device-width: 640px){
    .cart-btn{
      padding: 10px 10px;
      width: 100%;
    }
  }
</style>
<script>
  import {
    ADD_TO_CART,
    REMOVE_FROM_CART
  } from '../../store/mutation-types'
  export default {
    props: ['productMain','productItemGroup','productItem'],
    data () {
      return {
        cart: this.$store.state.cart
      }
    },
    computed: {
      canAdd () {
        // return this.cart.indexOf(this.productItem) < 0
        const index = this.cart.findIndex(p => p.product_item_id === this.productItem.product_item_id) //best removal
        if(index < 0){
          return true;
        }
      }
    },
    methods: {
      addToCart () {
        this.productItem._id = this.productItem.product_item_id;
        //config qty if not set
        if(this.productItem.product_item_order_quantity == undefined){
          this.productItem.product_item_order_quantity = 1;
        }
        this.productItem.product_main_id = this.productMain.product_id;
        this.productItem.product_business = this.productMain.product_business_ownername;
        this.productItem.product_name = this.productMain.product_name;
        this.productItem.product_url = this.productMain.product_business_ownername+"/"+this.productMain.product_url_name;
        //some settings for product items images
        if((this.productItemGroup.product_item_group_is_color_image == 'IMG') && (this.productItemGroup.product_item_group_image != 'error')){
          this.productItem.product_item_image = this.productItemGroup.product_item_group_image;
        }else{ //is color or error
          this.productItem.product_item_image = '';
        }
        this.$store.commit(ADD_TO_CART, this.productItem)
      },
      // removeFromCart (id) {
      //   this.$store.commit(REMOVE_FROM_CART, id)
      // },
      removeFromCart (payload) {
        this.$store.commit(REMOVE_FROM_CART, payload)
      },
      redir(rlink){
            location.replace("/"+rlink)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// ProductCartActions.vue?261f49d8